import React from 'react';
import ContactForm from './ContactForm/ContactForm.jsx';
import ContactItem from './ContactItem/ContactItem.jsx';
import IsFetchingInline from '../../common/IsFetchingInline.jsx';

function Contacts(props) {
  let contactItems = props.contacts.map(c => <ContactItem key={c.id}
                                                          isFetching={props.isUpdateFetching && props.updateContactId === c.id}
                                                          onDelete={props.onDelete}
                                                          onChange={props.onChange}
                                                          contactId={c.id}
                                                          type={c.type}
                                                          type_name={c.type_name}
                                                          account={c.account}
                                                          account_link={c.original_link}/>)
  return <div>
    <div className="font-weight-bold">{gettext('Контакты')}:</div>
    <p className="small text-secondary">
      {gettext('Добавьте любое количество своих контактов, чтобы другим участникам и посетителям было проще связаться с вами.')}<br/>
      {gettext('Для редактирования контакта кликните по его значению.')}
    </p>
    {contactItems}
    <IsFetchingInline isFetching={props.isCreateFetching}/>
    <ContactForm onSubmit={props.onSubmit}/>
  </div>
}

export default Contacts;